import type { LilliSettings } from "@/getSettings";

export default {
  // NOTE: privacy policy and tos may contain a string $langcode which will be replaced with the currently set language code of the user
  termsAndConditionsLink: "https://www.limbachgruppe.com/agb/",
  privacyPolicyLink: "https://www.limbachgruppe.com/datenschutz/",
  imprintLink: "https://www.limbachgruppe.com/impressum/",
  headerlogo: "/img/logo.svg",
  loginImage: "/img/login-image.svg",
  showDetailsForQuiz: false,
  showDetailsForSurvey: false,
  showSeal: false,
  showCovidView: false,
  showCovidCertificatesToAdmin: false,
  showTestCenterView: false,
  showHardwareRestrictions: true,
  userStateShowDownload: true,
  publicSharedAccount: 3,
  customCertificateImage: "/img/certificate.webp",
  coursesHideStar: true,
  eventsHideFreeSeats: true,
  hideContentManager: true,

  // Default settings for customers used in various places as defaults, using the according prefix.
  defaultSettings: {
    event: {
      selfRegistration: true,
      selfRegistrationAllUsersInAccount: true,
    },
    publication: {
      mandatory: false,
      generateCertificate: true,
    },
  },
  courseListDescription: "provider",
  title: "Limbach Akademie",
  courseProviderShareEnabled: true,
  registrationRequiresKey: true,
  registrationLinkOnLoginKey: "gast",
  hidePrivacyPolicy: true,
  showMarketingConsent: true,
  hasRegistrationSteps: true,
  showEventCategoryOnCard: true,
  flexLessonCompletedImage: "/img/lesson-completed.webp",
  flexCourseCompletedImage: "/img/course-completed.webp",
  coursesUseImageSelector: true,
  additionalCertificateTextEnabled: true,
  registrationSteps: [
    {
      label: "",
    },
    {
      label: "practiceClinicInstitution",
    },
    {
      label: "",
    },
  ],

  // possible values: phone, address, birthday, company, lastname, firstname, birthyear
  registrationRequiredDetails: {
    phone: { request: false, mandatory: false },
    address: { request: false, mandatory: false },
    title: { request: true, mandatory: false, step: 1 },
    firstname: { request: true, mandatory: true, step: 1 },
    lastname: { request: true, mandatory: true, step: 1 },
    birthday: { request: false, mandatory: false },
    company: { request: false, mandatory: false },
    emergencyContact: { request: false, mandatory: false },
  },
  customEventDateFields: {
    customizationId: "limbach",
    fields: [
      {
        label: "vnr",
        property: "vnr",
        type: "text",
        required: false,
        regex: "^[0-9]{19}$",
        regexDescription: "vnrValidationMessage",
      },
    ],
  },
  reportsVisibility: {
    userOrdersAggregate: { visible: true, order: 1 },
    courseSessionsAggregate: { visible: true, order: 2 },
    userSessionsList: { visible: true, order: 3 },
    ordersUserList: { visible: true, order: 4 },
    coursesUserCompleted: { visible: true, order: 5 },
    usersRoleAssignments: { visible: true, order: 7 },

    userCompletionsList: { visible: false },

    coursesUserAssignments: { visible: false },
    accountStatistics: { visible: false },
    usersTheoreticalCourses: { visible: false },
    usersPracticalTests: { visible: false },
    testReport: { visible: false },
    usersCovid: { visible: false },
    usersStates: { visible: false },
  },
  customRegistrationFields: {
    fields: [
      {
        label: "nameOrDescription",
        type: "text",
        attributes: true,

        property: "companyName",
        step: 1,
        mandatory: true,
      },
      {
        label: "streetHouseNumber",
        type: "text",
        attributes: true,
        property: "companyStreetHouseNumber",
        step: 1,
        mandatory: true,
      },
      {
        label: "zipCode",
        type: "text",

        attributes: true,
        property: "companyZipCode",
        step: 1,
        mandatory: true,
      },
      {
        label: "city",
        type: "text",
        attributes: true,
        property: "companyCity",
        step: 1,
        mandatory: true,
      },
      {
        label: "bsnr",
        type: "text",
        attributes: true,
        property: "companyBsnr",
        step: 1,
        nullable: true,
        nullLabel: "noBSNRNumber",
        mandatory: true,
        regex: "^[0-9]{9}$",
        regexDescription: "bsnrValidationMessage",
      },
      {
        label: "efn",
        type: "text",
        attributes: true,
        property: "efn",
        step: 2,
        mandatory: false,
        regex: "^[0-9]{15}$",
        regexDescription: "efnValidationMessage",
      },
    ],
  },
  qGateFields: [
    { id: "birthdate", type: "date", label: "birthday", mandatory: true },
    // {id: 'birthplace', type: 'string', label: 'birthplace', mandatory: true},
    // NOTE: nationalityWithNonEuVisa also adds the additional, optional fields socialSecurity and workPermit (if the user is not from the EU)
    {
      id: "nationality",
      type: "nationalityWithNonEuVisa",
      label: "nationality",
      mandatory: true,
    },
    // {id: 'address', type: 'string', label: 'address', mandatory: true},
    // {id: 'city', type: 'string', label: 'city', mandatory: true},
    // {id: 'zipCode', type: 'string', label: 'zipCode', mandatory: true},
    {
      id: "emergencyContact",
      type: "string",
      label: "emergencyContact",
      mandatory: false,
    },
    {
      id: "emergencyContactPhone",
      type: "string",
      label: "emergencyContactPhone",
      mandatory: false,
    },
    // {id: 'country', type: 'country', label: 'country', mandatory: true},
    {
      id: "car",
      type: "switchString",
      label: "driveInPermit",
      mandatory: false,
      settings: { subLabel: "carPlate", subId: "carPlate" },
    },
  ],
  userEditableTagTypes: ["Beruf", "Fachrichtung"],
  emailAsUsername: true,
  supportedLanguages: ["de", "en"],
  defaultLanguage: "de",
  registrationKeyMinimumLength: 4,
  showRequiredFieldAnnotationInRegistration: true,
  showRegistrationSideText: true,
  courseAdminListFields: ["owner"],
  passwordRegex: "^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[^a-zA-Z0-9]).+$",

  // Language overrides allow to override specific values for translation files, this is an example to change 'Zertifikat' to 'Teilnahmebescheinigung'
  languageOverrides: {
    de: {
      bsnrValidationMessage:
        "Die BSNR muss genau 9 Zahlen enthalten (z.B. 123456789).",
      efnValidationMessage:
        "Die EFN muss genau 15 Zahlen enthalten (z.B. 123456789012345).",
      practiceClinicInstitution: "Praxis/Klinik/Institution",
      atLeastOneBigAndSmall:
        "Mindestens ein Groß- und Kleinbuchstabe, eine Zahl und ein Sonderzeichen",
      passwordError:
        "Das Passwort muss mindestens 8 Zeichen lang sein und mindestens einen Großbuchstaben, einen Kleinbuchstaben, eine Zahl und ein Sonderzeichen enthalten.",
      bsnr: "BSNR",
      efn: "EFN",
      streetHouseNumber: "Straße und Hausnummer",
      nameOrDescription: "Name bzw. Bezeichnung",
      registrationSideText: `<h1>Kostenlose Registrierung</h1>
    <p>Um sich für die Fortbildungen der Limbach Gruppe anzumelden, müssen Sie nur einmalig Ihre Benutzerdaten hinterlegen. Dies bietet Ihnen zahlreiche Vorteile: </p>
    <ul>
      <li>✓ <strong>Einfache Anmeldung:</strong> Für künftige Anmeldungen reicht ein einfacher Login in unserem Portal.</li><br>
      <li>✓ <strong>Zertifikatsverwaltung:</strong> Verwalten Sie Ihre Fortbildungszertifikate bequem an einem Ort.</li><br>
      <li>✓ <strong>Materialien herunterladen:</strong> Greifen Sie auf alle benötigten Materialien schnell und unkompliziert zu.</li><br>
      <li>✓ <strong>On-Demand Veranstaltungen:</strong> Besuchen Sie On-Demand Veranstaltungen jederzeit, wann und wo es Ihnen passt.</li><br>
    </ul>
    <p>Registrieren Sie sich jetzt und nutzen Sie die zahlreichen Vorteile unseres Fortbildungsportals!</p>
    `,
      noBSNRNumber: "Keine BSNR-Nummer vorhanden",
      courses: {
        certificate: "Teilnahmebescheinigung",
        certificates: "Teilnahmebescheinigungen",
        printCertificate: "Teilnahmebescheinigung drucken",
      },
      vnr: "VNR",
      quizzes: {
        downloadCertificate:
          "Sie können jederzeit ihre Teilnahmebescheinigung unter Teilnahmebescheinigungen im Profil herunterladen und via E-Mail anfordern.",
      },
      termsAndConditions: "AGB",
      unregister: "Stornieren",
      confirmUnregister: "Storno bestätigen",
      confirmUnregisterBody:
        "Sind Sie sicher, dass Sie die Anmeldung für diesen Termin stornieren möchten?",
      vnrValidationMessage:
        "Die VNR muss genau 19 Zahlen enthalten (z.B. 1234567890123456789).",
    },
    en: {
      bsnrValidationMessage:
        "The BSNR must contain exactly 9 digits (e.g. 123456789).",
      efnValidationMessage:
        "The EFN must contain exactly 15 digits (e.g. 123456789012345).",
      practiceClinicInstitution: "Practice/Clinic/Institution",
      bsnr: "BSNR",
      efn: "EFN",
      streetHouseNumber: "Street and House Number",
      nameOrDescription: "Name or Description",
      atLeastOneBigAndSmall:
        "At least one uppercase letter, one lowercase letter, one number, and one special character",
      registrationSideText: `<h1>Free Registration</h1>
    <p>To register for the training courses of the Limbach Group, you only need to enter your user data once. This offers you numerous advantages:</p>
    <ul>
      <li>✓ <strong>Easy Registration:</strong> For future registrations, a simple login to our portal is sufficient.</li><br>
      <li>✓ <strong>Certificate Management:</strong> Manage your training certificates conveniently in one place.</li><br>
      <li>✓ <strong>Download Materials:</strong> Access all necessary materials quickly and easily.</li><br>
      <li>✓ <strong>On-Demand Events:</strong> Attend on-demand events anytime, anywhere that suits you.</li><br>
    </ul>
    <p>Register now and take advantage of the many benefits of our training portal!</p>
    `,
      noBSNRNumber: "No BSNR number available",
      vnr: "VNR",
      vnrValidationMessage:
        "The VNR must contain exactly 19 digits (e.g. 1234567890123456789).",
      passwordError:
        "The password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one number, and one special character.",
    },
  },
} satisfies LilliSettings;
